export const build = {
  commit: 'd221c7c',
  buildTime: '2026-10-20T22:40:06.158Z',
  env: 'local',
};
